type DataRecord = Record<string, unknown>;

export const escapeRegExp = (value: string): string => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

const buildComparator = (
  a: DataRecord,
  b: DataRecord,
  orderBy: string,
  sortOrder: "asc" | "desc",
): number => {
  if (orderBy) {
    if (
      (a[orderBy] === undefined || !a[orderBy]) &&
      b[orderBy] &&
      sortOrder === "asc"
    )
      return -1;
    if (
      (b[orderBy] === undefined || !b[orderBy]) &&
      a[orderBy] &&
      sortOrder === "asc"
    )
      return 1;
    if (!a[orderBy]) return 1;
    if (!b[orderBy]) return -1;
    return (
      String(a[orderBy]).localeCompare(String(b[orderBy]), "en", {
        numeric: true,
      }) * (sortOrder === "asc" ? 1 : -1)
    );
  }
  return 0;
};

export const getComparator = (order: "asc" | "desc", orderBy: string) => {
  return (a: DataRecord, b: DataRecord): number =>
    buildComparator(a, b, orderBy, order);
};
